@if (isDetailsLoaded == null) {
  <div class="body-padding">
    <div class="w-full flex flex-col items-center justify-center gap-4 py-20">
      <loading-spinner [size]="'4rem'"/>
      <div class="text-xl text-gray-600 dark:text-gray-400">Loading job details...</div>
    </div>
  </div>
} @else if (!isDetailsLoaded) {
  <div class="body-padding">
    <div class="w-full text-xl flex items-center justify-center">
      Job Not Found
    </div>
  </div>
} @else {
  <div class="body-padding">
    <div class="flex flex-col items-baseline mb-4 gap-4 w-full">
      <span>
        <div><span (click)="returnToJobs()" class="text-blue-500 text-sm font-normal cursor-pointer">Jobs</span><span
          class="text-zinc-500 text-sm font-normal"> / #{{ jobNumber }}</span></div>
      </span>
      <div class="text-gray-900 text-[32px] font-bold font-['Roboto Slab'] leading-9 tracking-wide">Job
        #{{ jobNumber }}
      </div>
    </div>
    <div class="flex flex-wrap items-baseline align-baseline">
      <div class="w-full px-8 py-4 bg-white rounded-xl shadow text-base">
        <key-value-pair-table [data]="jobDetailsFields"/>
      </div>
    </div>
    <div id="comments_tab">
      <ul
        class="flex gap-2 flex-wrap text-lg font-normal text-center border-b border-gray-400 dark:border-gray-600 mb-1"
        id="default-tab" role="tablist">
        <li>
          <button id="assets-tab" class="tab-button" [class.selected-tab-button]="activeTab === 'assets'"
                  type="button" role="tab" aria-controls="assets" (click)="changeTab('assets')">
            Assets ({{ assetsTableData.data.length }})
          </button>
        </li>
        <li>
          <button id="upcoming-tab" class="tab-button" [class.selected-tab-button]="activeTab === 'attachments'"
                  type="button" role="tab" aria-controls="attachments" (click)="changeTab('attachments')">
            Attachments ({{ getTotalNumber(jobAttachments) }})
          </button>
        </li>
        <li>
          <button id="upcoming-tab" class="tab-button" [class.selected-tab-button]="activeTab === 'comments'"
                  type="button" role="tab" aria-controls="comments" (click)="changeTab('comments')">
            Comments ({{ jobComments.length }})
          </button>
        </li>
        <li>
          <button id="upcoming-tab" class="tab-button" [class.selected-tab-button]="activeTab === 'history'"
                  type="button" role="tab" aria-controls="history" (click)="changeTab('history')">
            History ({{ historyTableData.data.length }})
          </button>
        </li>
      </ul>
    </div>
    <div id="default-tab-content">
      @switch (activeTab) {
        @case ('assets') {
          <custom-table [columns]="assetsColumns()" [data]="assetsTableData" [loading]="loadingAssets"
                        primaryDataKey="AssetId" [usePagination]="false" [visibleHeader]="false"
                        [customRowClasses]="['align-top']"/>
        }
        @case ('attachments') {
          <job-attachments [jobId]="jobId" [attachments]="jobAttachments"/>
        }
        @case ('comments') {
          <comments-section [data]="jobComments" [loading]="loadingComments" (create)="createComment($event)"
                            (edit)="editComment($event)" (delete)="deleteComment($event)"/>
        }
        @case ('history') {
          <history-table [data]="historyTableData" [loading]="loadingHistory"/>
        }
      }
    </div>
  </div>
}

<ng-template #assetColumn let-row>
  <div class="flex flex-col">
    <div class="flex">
      <div class="flex pt-3 pb-3 h-1 pr-5 pl-5 text-zinc-950 text-sm font-normal">
        {{ row[JobAssetsColumn.Index] + 1 }}
      </div>
      <div>
        <span style="{{row['IsOwner']?'':'color:gray'}}" class="font-bold">
          {{ row[JobAssetsColumn.Asset] }}
        </span>
        @if (!row[JobAssetsColumn.IsOwner]) {
          <div class="custom-tooltip-not-owned-warning">
            <svg class="w-4 h-4 text-gray-500" aria-hidden="true"
                 xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 20">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 13V8m0 8h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
            </svg>
            <div class="custom-tooltip-not-owned-warning-text">
              This Asset has been relocated to another Company.
            </div>
          </div>
        }
        <br>
        <div class="text-zinc-500 text-sm font-['Inter']">
          <span>SN: </span>
          <span class="font-bold">{{ row[JobAssetsColumn.SerialNumber] }}</span>
        </div>
      </div>
    </div>
    <div class="flex gap-2 flex-col text-sm font-['Inter'] pt-5">
      <div>
        <span class="text-zinc-500">Asset #: </span>
        <span class="text-[#0F0D15]">{{ row[JobAssetsColumn.AssetNumber] }}</span>
      </div>
      <div>
        <span class="text-zinc-500">PO Number: </span>
        <span class="text-[#0F0D15]">{{ row[JobAssetsColumn.PoNumber] }}</span>
      </div>
      <div class="text-zinc-500">Accessories</div>
      <div class="text-[#0F0D15]">{{ row[JobAssetsColumn.Accessories] }}</div>
      <div class="text-zinc-500">Issue Description</div>
      <div class="text-[#0F0D15]">{{ row[JobAssetsColumn.CustomerConcern] }}</div>
      @if (currentUser?.is_owner == 0 && currentUser?.is_rentee == 1) {
        <div class="text-zinc-500">Device Checks</div>
        <div class="text-[#0F0D15]">{{ row[JobAssetsColumn.DeviceChecks] }}</div>
        <div class="text-zinc-500">Corrective Actions</div>
        <div class="text-[#0F0D15]">{{ row[JobAssetsColumn.CorrectiveActions] }}</div>
      }
    </div>
  </div>
</ng-template>

<ng-template #boldField let-data>
  <span class="font-bold">{{ data }}</span>
</ng-template>
<ng-template #tagField let-data>
  <tags [tags]="[data]"/>
</ng-template>
<ng-template #locationField let-data>
  <div class="flex gap-2 flex-col">
    <span class="font-semibold">{{ data.name }}</span>
    <span>{{ data.address }}</span>
    @if (data.phone) {
      <span>{{ data.phone }}</span>
    }
  </div>
</ng-template>
